/**
 * URL Configuration
 * Centralized configuration for application URLs
 */

// Default port for React development server
export const DEFAULT_PORT = 3000;

// Base URL for the application
// Use environment variable if set, otherwise use hardcoded IP for development
// Note: Ensure the port is included if your dev server runs on a specific port
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || `http://192.168.1.54:${DEFAULT_PORT}`; // Default to local IP address with port

// Assignment route path
export const ASSIGNMENT_ROUTE = "/assignment";

/**
 * Generate employee assignment page URL
 * @param {string} pageId - The employee page ID
 * @returns {string} Full URL to the employee assignment page
 */
export const getAssignmentUrl = (pageId) => {
  return `${BASE_URL}${ASSIGNMENT_ROUTE}/${pageId}`;
};
